import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from '@douyinfe/semi-ui';
import App from './App';
import ParticleBackground from './components/ParticleBackground';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import { ThemeProvider } from './context/Theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { Content } = Layout;
root.render(
  <ThemeProvider>
    {/* 装饰性浮动元素 */}
    <div className="floating-orb"></div>
    <div className="floating-orb"></div>
    <div className="floating-orb"></div>
    
    {/* 粒子背景 */}
    <ParticleBackground />
    
    <Layout>
      <Content style={{ padding: 24 }}>
        <App />
      </Content>
    </Layout>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
